// extracted by css-extract-rspack-plugin
export default {"root":"VDUDtS","thumb-overlay-icon":"k5R7Tg","thumbOverlayIcon":"k5R7Tg"};